import Person from "./Person.interface"

export default interface Group {
    id: number
    object?: string
    name: string
    description: string
    required: boolean
    query: GroupQuery
    persons_count: number
    persons_ids: number[]
    persons?: Person[]
    campaign_id: number
    channel_id: number
    archived: boolean
    important: boolean
    created_at: string
    updated_at: string
    deleted_at: string
    bucket: GroupBucket
    unread_count?: number
    flag?: boolean
    snapshot?: boolean
}

export interface GroupBucket {
    order?: number
    color?: string
    group?: Group
}

export interface GroupCount {
    id: number
    count: number
}

export interface GroupQuery {
    exceptions: number[]
    queries: BasicQuery[]
}

export interface BasicQuery {
    type: BasicQueryType
    has: string
    where: BasicQueryWhere[]
}

export interface BasicQueryWhere {
    column: string
    operator: string
    value: string
}

export enum BasicQueryType {
    has = 'has',
    where = 'where',
    whereHas = 'whereHas',
    user = 'user',
    not_user = 'not_user',
    orWhereNull = 'orWhereNull'
}
